import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit, HostListener } from '@angular/core';
import { MachineListHttpService, MachineListDataSource } from '../../../core/machine-list';
import { MatPaginator, MatSnackBar, MatSort } from '@angular/material';
import { tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { merge, fromEvent } from 'rxjs';
import { Cache } from 'aws-amplify';
import { MachineService, PreviousRouteService } from '../../../../app/core/_base/layout';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { MixpanelService } from '../../../services/mixpanel.service';
import { FilterParams } from '../../../core/filter-options/filter-options.service';
import { SelectOption } from '../../partials/content/general/searchable-select/searchable-select.component';
import { formatLocalDate, isBrewVisionWorking } from '../../../core/machine-camera/_services/machine-camera.util';


@Component({
  selector: 'kt-machine-list',
  templateUrl: './machine-list.component.html',
  styleUrls: ['./machine-list.component.css']
})
export class MachineListComponent implements OnInit, AfterViewInit {

	mMachineList;
	filterStatus = '';
	filterStatusValue: (string | number)[] = [];
	filterConn = '';
	filterConnValue: (string | number)[] = [];
	filterConnection = '';
	filterMacStatus = '';
	filterMacStatusValue: (string | number)[] = [];
	filterVendMode = '';
	filterVendModeValue: (string | number)[] = [];
	// Super admins only: machines with or without an installed camera.
	filterCamera = '';
	filterCameraValue: (string | number)[] = [];
	loading = false;
	isAssigned = false;

	connectivityOptions: SelectOption[] = [
		{ value: '', label: 'All' },
		{ value: '1', label: 'Online' },
		{ value: '0', label: 'Offline' }
	];

	statusOptions: SelectOption[] = [
		{ value: '', label: 'All' },
		{ value: '0', label: 'No Issues' },
		{ value: '1', label: 'Open Warnings' },
		{ value: '2', label: 'Open Issues' }
	];

	machineStatusOptions: SelectOption[] = [
		{ value: '', label: 'All' },
		{ value: '1', label: 'Warehouse' },
		{ value: '2', label: 'Production' }
	];

	vendModeOptions: SelectOption[] = [
		{ value: '', label: 'All Machines' },
		{ value: 'ocs', label: 'OCS' },
		{ value: 'retail', label: 'Retail' }
	];

	cameraOptions: SelectOption[] = [
		{ value: '', label: 'All Machines' },
		{ value: 'with', label: 'With BrewVision' },
		{ value: 'without', label: 'Without BrewVision' }
	];


	private defaultParams = {
		noPerPg: 50,
		pgNo: 0,
		sortKey: 'serial_no',
		sortVal: 'asc',
		optFilterKey: 'connectivity',
		optFilterVal: '',
		optFilterKey1: 'machine_status',
		optFilterVal1: '',
		optFilterKey2: 'deployment_status',
		optFilterVal2: '',
		vendModeScope: '',
		cameraScope: '',
		txtFilterKey: 'location_name',
		txtFilterVal: '',
		disti_id: null,
		client_id: null,
		campus_id: null,
		market_id: null
	};



	dataSource: MachineListDataSource;

	@ViewChild('searchInput', {static: true}) searchInput: ElementRef;

	displayedColumns = ['machine_id', 'serial_no', 'machine_name', 'machine_status', 'connectivity'];



	isFilterCached = false;

	selectedDisti = {disti_id: null};
	selectedClient = {client_id: null};
	selectedCampus = {campus_id: null};
	selectedMarket = {market_id: null};
	distiName = 'All Partners';
	clientName = 'All Clients';
	campusName = 'All Campuses';
	marketName = 'All Markets';
	user;
	role;
	disti_id;
	client_id;
	campus_id;

	navToUrls = ['/machine/sales', '/machine/open-issues'];

	qParams = {};

	/** Initial selection for hierarchical filters when navigating from dashboard with scope in URL */
	hierarchicalFilterInitialValues?: {
		distributorIds?: (string | number)[];
		marketIds?: (string | number)[];
		clientIds?: (string | number)[];
		campusIds?: (string | number)[];
		machineIds?: (string | number)[];
	};

	// Custom tooltip properties
	tooltipVisible = false;
	tooltipX = 0;
	tooltipY = 0;
	tooltipHtml = '';

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild(MatSort, {static: false}) sort: MatSort;

	@ViewChild('searchInput', {static: false}) input: ElementRef;

	@ViewChild('tooltipElement', {static: false}) tooltipElement: ElementRef;

	constructor(private http: MachineListHttpService,
				private cdr: ChangeDetectorRef,
				private machineService: MachineService,private _snackBar: MatSnackBar,
				private route: ActivatedRoute,
				private router: Router,
				private mixpanelService: MixpanelService,
				private previousRoute: PreviousRouteService) { }

	ngOnInit() {
		this.user = Cache.getItem('userAttr');
		this.role = this.user['custom:role'];
		if (this.role === 'sadmin') {
			this.displayedColumns = [...this.displayedColumns, 'brewvision'];
		}
		if(this.user['custom:disti_id'])
			this.selectedDisti = {disti_id: this.user['custom:disti_id']};
		if(this.user['custom:client_id'])
			this.selectedClient = {client_id: this.user['custom:client_id']};
		if(this.user['custom:campus_id'])
			this.selectedCampus = {campus_id: this.user['custom:campus_id']};
		this.dataSource = new MachineListDataSource(this.http);

		// Apply initial state from URL (sync) so hierarchical filter has initialValues on first render
		const snapshotParams = this.route.snapshot.queryParams;
		this.applyScopeFromQueryParams(snapshotParams);

		this.route.queryParams.subscribe(params => {
			if (params && params.error === 'machine_not_found') {
				this._snackBar.open('Machine not found. It may have been removed or the link is invalid.', 'Close', { duration: 6000 });
				this.router.navigate(['/machine-list'], { queryParams: {}, replaceUrl: true });
				return;
			}
			if (params) {
				if (params.filterConn) {
					this.filterConn = params.filterConn;
					this.filterConnValue = [params.filterConn];
				}
				if (params.filterStatus) {
					this.filterStatus = params.filterStatus;
					this.filterStatusValue = [params.filterStatus];
				}
				if (params.filterVendMode && this.role === 'sadmin') {
					this.filterVendMode = params.filterVendMode;
					this.filterVendModeValue = [params.filterVendMode];
				}
				if (params.filterCamera && this.role === 'sadmin') {
					this.filterCamera = params.filterCamera;
					this.filterCameraValue = [params.filterCamera];
				}
				this.applyScopeFromQueryParams(params);
			}
			this.qParams = {
				noPerPg: this.paginator.pageSize || 50,
				pgNo: this.paginator.pageIndex || 0,
				sortKey: 'serial_no',
				sortVal: 'asc',
				optFilterKey: 'connectivity',
				optFilterVal: this.filterConn || '',
				optFilterKey1: 'machine_status',
				optFilterVal1: this.filterStatus || '',
				optFilterKey2: 'deployment_status',
				optFilterVal2: this.filterMacStatus || '',
				vendModeScope: this.role === 'sadmin' ? this.filterVendMode || '' : '',
				cameraScope: this.role === 'sadmin' ? this.filterCamera || '' : '',
				disti_id: this.selectedDisti ? this.selectedDisti.disti_id : null,
				client_id: this.selectedClient ? this.selectedClient.client_id : null,
				campus_id: this.selectedCampus ? this.selectedCampus.campus_id : null,
				market_id: this.selectedMarket ? this.selectedMarket.market_id : null
			};
			this.dataSource.loadMachineList(this.qParams);
		});

		this.mixpanelService.track(this.mixpanelService.PAGE_VIEW)
	}

	/**
	 * Parse first value from a query param (string or comma-separated).
	 */
	private firstParamValue(val: string | string[] | undefined): string | null {
		if (val == null || val === '') return null;
		const s = Array.isArray(val) ? val[0] : val;
		if (!s) return null;
		const first = s.split(',')[0];
		return first ? first.trim() : null;
	}

	/**
	 * Coerce a string ID to number when numeric so it matches API option values (SelectOption.value).
	 * URL params are always strings; the hierarchical filter options use numeric IDs from the API.
	 */
	private parseIdForOption(s: string | null): string | number | null {
		if (s == null || s === '') return null;
		const trimmed = s.trim();
		if (/^\d+$/.test(trimmed)) return Number(trimmed);
		return trimmed;
	}

	/**
	 * Apply partner/client/campus/market from URL query params (e.g. when navigating from dashboard with filters).
	 * When any scope param is present, only the provided params are set; others are cleared.
	 */
	private applyScopeFromQueryParams(params: Record<string, string | string[]>): void {
		const hasScope = params.disti_id != null || params.market_id != null || params.client_id != null || params.campus_id != null;
		if (!hasScope) return;

		const distiId = this.firstParamValue(params.disti_id);
		const marketId = this.firstParamValue(params.market_id);
		const clientId = this.firstParamValue(params.client_id);
		const campusId = this.firstParamValue(params.campus_id);

		this.selectedDisti = distiId != null ? { disti_id: distiId } : { disti_id: null };
		this.distiName = distiId != null ? 'Selected' : 'All Partners';

		this.selectedMarket = marketId != null ? { market_id: marketId } : { market_id: null };
		this.marketName = marketId != null ? 'Selected' : 'All Markets';

		this.selectedClient = clientId != null ? { client_id: clientId } : { client_id: null };
		this.clientName = clientId != null ? 'Selected' : 'All Clients';

		this.selectedCampus = campusId != null ? { campus_id: campusId } : { campus_id: null };
		this.campusName = campusId != null ? 'Selected' : 'All Campuses';

		const distiParsed = distiId != null ? this.parseIdForOption(distiId) : null;
		const marketParsed = marketId != null ? this.parseIdForOption(marketId) : null;
		const clientParsed = clientId != null ? this.parseIdForOption(clientId) : null;
		const campusParsed = campusId != null ? this.parseIdForOption(campusId) : null;

		this.hierarchicalFilterInitialValues = {
			distributorIds: distiParsed != null ? [distiParsed] : [],
			marketIds: marketParsed != null ? [marketParsed] : [],
			clientIds: clientParsed != null ? [clientParsed] : [],
			campusIds: campusParsed != null ? [campusParsed] : [],
			machineIds: []
		};
	}

	onClearFilters() {
		this.isFilterCached = false;
		this.machineService.clearMacListFilters();
		this.loadMachineListPage();
	}

	onFiltersChange(params: FilterParams): void {
		// Update selected entities from FilterParams
		const previousDistiId = this.selectedDisti ? this.selectedDisti.disti_id : null;

		if (params.disti_id) {
			const distiId = Array.isArray(params.disti_id) ? params.disti_id[0] : params.disti_id;
			this.selectedDisti = { disti_id: distiId };
			this.distiName = 'Selected';

			// Reset dependent selections if distributor changed
			if (previousDistiId !== distiId) {
				this.selectedMarket = { market_id: null };
				this.marketName = 'All Markets';
				this.selectedClient = { client_id: null };
				this.clientName = 'All Clients';
				this.selectedCampus = { campus_id: null };
				this.campusName = 'All Campuses';
			}
		} else {
			this.selectedDisti = { disti_id: null };
			this.distiName = 'All Partners';
		}

		if (params.market_id) {
			const marketId = Array.isArray(params.market_id) ? params.market_id[0] : params.market_id;
			this.selectedMarket = { market_id: marketId };
			this.marketName = 'Selected';
		} else {
			this.selectedMarket = { market_id: null };
			this.marketName = 'All Markets';
		}

		if (params.client_id) {
			const clientId = Array.isArray(params.client_id) ? params.client_id[0] : params.client_id;
			this.selectedClient = { client_id: clientId };
			this.clientName = 'Selected';

			// Reset campus if client changed
			if (!params.campus_id) {
				this.selectedCampus = { campus_id: null };
				this.campusName = 'All Campuses';
			}
		} else {
			this.selectedClient = { client_id: null };
			this.clientName = 'All Clients';
		}

		if (params.campus_id) {
			const campusId = Array.isArray(params.campus_id) ? params.campus_id[0] : params.campus_id;
			this.selectedCampus = { campus_id: campusId };
			this.campusName = 'Selected';
		} else {
			this.selectedCampus = { campus_id: null };
			this.campusName = 'All Campuses';
		}

		this.loadMachineListPage();
		this.cdr.detectChanges();
	}

	ngAfterViewInit() {
		fromEvent(this.searchInput.nativeElement, 'keyup')
		.pipe(
			debounceTime(250),
			distinctUntilChanged(),
			tap(() => {
				// console.log('Search triggered');
				this.paginator.pageIndex = 0;
				this.loadMachineListPage();
			})
		)
		.subscribe();

		this.dataSource.counter$
		.pipe(
			tap((count) => {
			this.paginator.length = count;
			})
		)
		.subscribe();

		this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

		merge(this.paginator.page, this.sort.sortChange).pipe(
			tap(() => {
				this.loadMachineListPage();
			})
		)
		.subscribe();

	}

	onConnectivityChange(values: (string | number)[]): void {
		this.filterConn = values && values.length > 0 ? String(values[0]) : '';
		this.loadMachineListPage();
	}

	onStatusChange(values: (string | number)[]): void {
		this.filterStatus = values && values.length > 0 ? String(values[0]) : '';
		this.loadMachineListPage();
	}

	onMachineStatusChange(values: (string | number)[]): void {
		this.filterMacStatus = values && values.length > 0 ? String(values[0]) : '';
		this.loadMachineListPage();
	}

	onVendModeChange(values: (string | number)[] | string | number): void {
		if (Array.isArray(values)) {
			this.filterVendMode = values.length > 0 ? String(values[0]) : '';
		} else {
			this.filterVendMode = values != null ? String(values) : '';
		}
		this.loadMachineListPage();
	}

	onCameraChange(values: (string | number)[] | string | number): void {
		if (Array.isArray(values)) {
			this.filterCamera = values.length > 0 ? String(values[0]) : '';
		} else {
			this.filterCamera = values != null ? String(values) : '';
		}
		this.loadMachineListPage();
	}

	// Super admins only.
	isBrewVisionWorking(machine: any): boolean {
		const brewvision = machine && machine.brewvision;
		return Boolean(brewvision) && isBrewVisionWorking(brewvision.status, brewvision.last_seen_utc);
	}

	onBrewVisionIconMouseEnter(event: MouseEvent, machine: any): void {
		this.showIconTooltip(event, this.getBrewVisionTooltipHtml(machine.brewvision, this.isBrewVisionWorking(machine)));
	}

	getBrewVisionTooltipHtml(brewvision: any, working: boolean): string {
		const parts: string[] = [];
		if (working) {
			parts.push('BrewVision online');
		} else if (brewvision.status === 'online') {
			parts.push('BrewVision not reporting');
		} else {
			parts.push('BrewVision offline');
		}
		const rows: [string, string][] = [
			['Last seen', this.formatConnectivityTimestamp(Date.parse(brewvision.last_seen_utc))],
			['Last reading', this.formatConnectivityTimestamp(Date.parse(brewvision.last_reading_utc))],
			['Software', brewvision.software_version],
			['Installed', formatLocalDate(brewvision.installed, true)],
			['Reason', brewvision.reason ? String(brewvision.reason).replace(/_/g, ' ') : '']
		];
		rows.forEach(([label, value]) => {
			if (value) {
				parts.push(`<em>${label}: ${this.escapeHtml(String(value))}</em>`);
			}
		});
		return parts.join('<br>');
	}

	loadMachineListPage() {
		// console.log("Calling from search");
		this.qParams = {
			noPerPg: this.paginator.pageSize,
			pgNo: this.paginator.pageIndex,
			sortKey: this.sort && this.sort.active ? this.sort.active : 'serial_no',
			sortVal: this.sort && this.sort.direction ? this.sort.direction : 'asc',
			optFilterKey: 'connectivity',
			optFilterVal: this.filterConn || '',
			optFilterKey1: 'machine_status',
			optFilterVal1: this.filterStatus || '',
			optFilterKey2: 'deployment_status',
			optFilterVal2: this.filterMacStatus || '',
			vendModeScope: this.role === 'sadmin' ? this.filterVendMode || '' : '',
			cameraScope: this.role === 'sadmin' ? this.filterCamera || '' : '',
			disti_id: this.selectedDisti ? this.selectedDisti.disti_id : null,
			txtFilterKey: 'machine_id',
    		txtFilterVal: this.searchInput.nativeElement.value.trim(),
			client_id: this.selectedClient ? this.selectedClient.client_id : null,
			campus_id: this.selectedCampus ? this.selectedCampus.campus_id : null,
			market_id: this.selectedMarket ? this.selectedMarket.market_id : null
		};
		// console.log(params);
		this.dataSource.loadMachineList(this.qParams);
	}

	onMachine(machine: any) {
		Cache.setItem('selected_machine', machine, {priority: 1});
		this.machineService.setMachine(machine);
		if (!(_.isEqual(this.qParams, this.defaultParams))) {
			this.machineService.setMacListFilters(this.qParams);
		}
		if (machine.machine_id) {
			this.router.navigate(['machine', machine.machine_id, 'inventory'], { state: { machine } });
		}
	}

	onStatClick(event: MouseEvent, machine: any): void {
		if (!machine || !machine.machine_status) return;
		if (event.ctrlKey || event.metaKey || event.button === 1) return;
		event.preventDefault();
		Cache.setItem('selected_machine', machine, {priority: 1});
		this.machineService.setMachine(machine);
		if (!(_.isEqual(this.qParams, this.defaultParams))) {
			this.machineService.setMacListFilters(this.qParams);
		}
		this.router.navigate(['machine', machine.machine_id, 'open-issues'], { state: { machine } });
	}

	navigateToRegisterMachine() {
		this.router.navigate(['register-machine']);
	}


	getItemStatusString(status: number = 0): string {
		if (status === null){
			return 'Ok';
		}
		switch (status) {
			case 0:
				return 'Ok';
			case 1:
				return 'Open Warning(s)';
			case 2:
				return 'Open Error(s)';
		}
		return 'NA';
	}

	getItemStatusTooltip(machine: any): string {
		if (!machine) {
			return this.getItemStatusString(undefined);
		}

		const status = machine.machine_status;

		// Parse errors and warnings - they may come as JSON strings or arrays
		const errors = this.parseErrorsOrWarnings(machine.errors);
		const warnings = this.parseErrorsOrWarnings(machine.warnings);

		// If no errors or warnings, return simple status
		if ((!errors || errors.length === 0) &&
		    (!warnings || warnings.length === 0)) {
			return this.getItemStatusString(status);
		}

		const lines: string[] = [];

		// Add errors if present
		if (errors && errors.length > 0) {
			lines.push(`Errors (${errors.length}):`);
			errors.forEach((error: any) => {
				const timestamp = this.formatTimestamp(error.time_stamp);
				lines.push(`  • ${error.log_msg}`);
				lines.push(`    ${timestamp}`);
			});
		}

		// Add warnings if present
		if (warnings && warnings.length > 0) {
			// Add separator if errors were shown
			if (lines.length > 0) {
				lines.push('');
			}
			lines.push(`Warnings (${warnings.length}):`);
			warnings.forEach((warning: any) => {
				const timestamp = this.formatTimestamp(warning.time_stamp);
				lines.push(`  • ${warning.log_msg}`);
				lines.push(`    ${timestamp}`);
			});
		}

		return lines.join('\n');
	}

	getItemStatusTooltipHtml(machine: any): string {
		if (!machine) {
			return this.escapeHtml(this.getItemStatusString(undefined));
		}

		const status = machine.machine_status;

		// Parse errors and warnings - they may come as JSON strings or arrays
		const errors = this.parseErrorsOrWarnings(machine.errors);
		const warnings = this.parseErrorsOrWarnings(machine.warnings);

		// If no errors or warnings, return simple status text
		if ((!errors || errors.length === 0) &&
		    (!warnings || warnings.length === 0)) {
			return this.escapeHtml(this.getItemStatusString(status));
		}

		const parts: string[] = [];

		// Add errors if present
		if (errors && errors.length > 0) {
			parts.push(`<strong>Errors (${errors.length}):</strong>`);
			errors.forEach((error: any) => {
				const timestamp = this.formatTimestamp(error.time_stamp);
				parts.push(`  • ${this.escapeHtml(error.log_msg)}`);
				parts.push(`    <em>${this.escapeHtml(timestamp)}</em>`);
			});
		}

		// Add warnings if present
		if (warnings && warnings.length > 0) {
			// Add separator if errors were shown
			if (parts.length > 0) {
				parts.push('');
			}
			parts.push(`<strong>Warnings (${warnings.length}):</strong>`);
			warnings.forEach((warning: any) => {
				const timestamp = this.formatTimestamp(warning.time_stamp);
				parts.push(`  • ${this.escapeHtml(warning.log_msg)}`);
				parts.push(`    <em>${this.escapeHtml(timestamp)}</em>`);
			});
		}

		return parts.join('<br>');
	}

	escapeHtml(text: string): string {
		if (!text) {
			return '';
		}
		const div = document.createElement('div');
		div.textContent = text;
		return div.innerHTML;
	}

	onStatusIconMouseEnter(event: MouseEvent, machine: any): void {
		const htmlContent = this.getItemStatusTooltipHtml(machine);
		this.tooltipHtml = htmlContent;
		this.tooltipVisible = true;

		// Capture the target element reference before the async callback
		const target = event.currentTarget as HTMLElement;

		// Use requestAnimationFrame to ensure DOM is fully laid out before calculating position
		requestAnimationFrame(() => {
			if (!target) {
				return;
			}
			// Position tooltip relative to the icon element (similar to Material tooltips)
			const rect = target.getBoundingClientRect();

			// Check if parent container has transform/positioning that affects fixed positioning
			let parentOffsetX = 0;
			let parentOffsetY = 0;
			let currentElement = target.parentElement;
			while (currentElement && currentElement !== document.body) {
				const computedStyle = window.getComputedStyle(currentElement);
				const transform = computedStyle.transform;
				if (transform && transform !== 'none') {
					// Parent has transform, which creates new containing block for fixed elements
					const parentRect = currentElement.getBoundingClientRect();
					parentOffsetX = parentRect.left;
					parentOffsetY = parentRect.top;
					break;
				}
				currentElement = currentElement.parentElement;
			}

			// Center horizontally on the icon, position above it
			// Account for parent container offset if it has transform
			this.tooltipX = rect.left + (rect.width / 2) - parentOffsetX;
			this.tooltipY = rect.top - 8 - parentOffsetY; // 8px above the icon

			this.cdr.detectChanges();
		});
	}

	onStatusIconMouseLeave(): void {
		this.tooltipVisible = false;
		this.cdr.detectChanges();
	}

	onConnectivityIconMouseEnter(event: MouseEvent, machine: any): void {
		this.showIconTooltip(event, this.getConnectionTooltipHtml(machine.connectivity, machine.conn_timestamp));
	}

	private showIconTooltip(event: MouseEvent, htmlContent: string): void {
		this.tooltipHtml = htmlContent;
		this.tooltipVisible = true;

		// Capture the target element reference before the async callback
		const target = event.currentTarget as HTMLElement;

		// Use requestAnimationFrame to ensure DOM is fully laid out before calculating position
		requestAnimationFrame(() => {
			if (!target) {
				return;
			}
			// Position tooltip relative to the icon element (similar to Material tooltips)
			const rect = target.getBoundingClientRect();

			// Check if parent container has transform/positioning that affects fixed positioning
			let parentOffsetX = 0;
			let parentOffsetY = 0;
			let currentElement = target.parentElement;
			while (currentElement && currentElement !== document.body) {
				const computedStyle = window.getComputedStyle(currentElement);
				const transform = computedStyle.transform;
				if (transform && transform !== 'none') {
					// Parent has transform, which creates new containing block for fixed elements
					const parentRect = currentElement.getBoundingClientRect();
					parentOffsetX = parentRect.left;
					parentOffsetY = parentRect.top;
					break;
				}
				currentElement = currentElement.parentElement;
			}

			// Center horizontally on the icon, position above it
			// Account for parent container offset if it has transform
			this.tooltipX = rect.left + (rect.width / 2) - parentOffsetX;
			this.tooltipY = rect.top - 8 - parentOffsetY; // 8px above the icon

			this.cdr.detectChanges();
		});
	}

	onConnectivityIconMouseLeave(): void {
		this.tooltipVisible = false;
		this.cdr.detectChanges();
	}

	@HostListener('window:scroll')
	onWindowScroll(): void {
		// Hide tooltip when scrolling to prevent it from staying at old mouse position
		if (this.tooltipVisible) {
			this.tooltipVisible = false;
			this.cdr.detectChanges();
		}
	}

	parseErrorsOrWarnings(value: any): any[] {
		if (!value) {
			return [];
		}

		// If it's already an array, return it
		if (Array.isArray(value)) {
			return value;
		}

		// If it's a string, try to parse it as JSON
		if (typeof value === 'string') {
			try {
				const parsed = JSON.parse(value);
				return Array.isArray(parsed) ? parsed : [];
			} catch (e) {
				return [];
			}
		}

		return [];
	}

	formatTimestamp(timestamp: string): string {
		if (!timestamp) {
			return '';
		}

		try {
			const date = new Date(timestamp);
			// Format as: "Jan 15, 2024 10:30 AM"
			return date.toLocaleString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: '2-digit',
				hour12: true
			});
		} catch (e) {
			return timestamp; // Return original if parsing fails
		}
	}

	getItemStatusIcon(status: number = 0): string {
		if (status === null){
			return 'check';
		}
		switch (status) {
			case 0:
				return 'check';
			case 1:
				return 'warning';
			case 2:
				return 'error'; // 'bug_report';
		}
		return 'NA';
	}

	getItemStatusColor(status: number = 0): string {
		if (status === null) {
			return 'text-success';
		}
		switch (status) {
			case 0:
				return 'text-success';
			case 1:
				return 'text-warning';
			case 2:
				return 'text-danger';
		}
		return 'text-secondary';
	}

	getItemConnectionStatusString(status: number = 0): string {
		switch (status) {
			case 0:
				return 'Offline';
			case 1:
				return 'Online';
		}
		return 'NA';
	}

	getConnectionTooltipHtml(status: number = 0, connTimestamp?: string | number): string {
		const statusText = this.getItemConnectionStatusString(status);
		const parts: string[] = [this.escapeHtml(statusText)];

		// If offline, add "Last seen" timestamp on second row
		if (status === 0 && connTimestamp) {
			const timestamp = this.formatConnectivityTimestamp(connTimestamp);
			if (timestamp) {
				parts.push(`<em>Last seen: ${this.escapeHtml(timestamp)}</em>`);
			}
		}

		return parts.join('<br>');
	}

	formatConnectivityTimestamp(timestamp: string | number): string {
		if (!timestamp) {
			return '';
		}

		try {
			// Handle Unix timestamp in milliseconds (as string or number)
			const timestampNum = typeof timestamp === 'string' ? parseInt(timestamp, 10) : timestamp;
			const date = new Date(timestampNum);

			// Format as: "Nov 19, 2024, 5:45 AM"
			return date.toLocaleString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: '2-digit',
				hour12: true
			});
		} catch (e) {
			return ''; // Return empty if parsing fails
		}
	}

	getConnectionIcon(status) {
		switch (status) {
			case 0:
				return 'cloud_off';
			case 1:
				return 'cloud_queue';
		}
		return 'cloud_off';
	}

	getConnectionColor(status) {
		switch (status) {
			case 0:
				return 'text-danger';
			case 1:
				return 'text-success';
		}
		return 'text-secondary';
	}


	showSnackBar(message: string, duration: number) {
		let snackRef = this._snackBar.open(message, 'close');
		if (duration > 0) {
			setTimeout(() => {
				this._snackBar.dismiss();
			}, duration);
		}

		snackRef.onAction().subscribe(() => {
			this._snackBar.dismiss();
		});
	}

	copyMachineId(machineId: string, event: Event): void {
		if (!machineId) {
			return;
		}

		// Use the Clipboard API
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(machineId).then(() => {
				this.showSnackBar(`Machine ID "${machineId}" copied to clipboard`, 2000);
			}).catch(() => {
				// Fallback for older browsers
				this.fallbackCopyToClipboard(machineId);
			});
		} else {
			// Fallback for browsers that don't support Clipboard API
			this.fallbackCopyToClipboard(machineId);
		}
	}

	private fallbackCopyToClipboard(text: string): void {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.position = 'fixed';
		textArea.style.left = '-999999px';
		textArea.style.top = '-999999px';
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			document.execCommand('copy');
			this.showSnackBar(`Machine ID "${text}" copied to clipboard`, 2000);
		} catch (err) {
			this.showSnackBar('Failed to copy Machine ID', 2000);
		}

		document.body.removeChild(textArea);
	}

	isSuperAdmin(): boolean {
		return this.role === 'sadmin';
	}

	/**
	 * Returns the full URL for a machine subpage so the link is a real href.
	 * Enables Cmd+click / right-click "Open in new tab" to work.
	 * Bound as instance property so the template always has a valid function reference.
	 */
	getMachineUrl = (machine: { machine_id?: string }, segment: string): string => {
		if (!machine || !machine.machine_id) {
			return '#';
		}
		const urlTree = this.router.createUrlTree(['machine', machine.machine_id, segment]);
		return window.location.origin + this.router.serializeUrl(urlTree);
	}

	/**
	 * Handles left-click on the machine link: SPA navigation. Cmd/Ctrl/middle-click are not prevented so the browser opens in new tab.
	 */
	onMachineClick(event: MouseEvent, machine: any): void {
		if (!machine || !machine.machine_id) {
			return;
		}
		if (event.ctrlKey || event.metaKey || event.button === 1) {
			return;
		}
		event.preventDefault();
		Cache.setItem('selected_machine', machine, { priority: 1 });
		this.machineService.setMachine(machine);
		if (!(_.isEqual(this.qParams, this.defaultParams))) {
			this.machineService.setMacListFilters(this.qParams);
		}
		this.router.navigate(['machine', machine.machine_id, 'inventory'], { state: { machine } });
	}

}
